import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Част от нещо по-голямо',
					text: 'Като част от <a href="https://team.blue" target="_blank" rel="nofollow">team.blue</a>, доверен европейски дигитален партньор с над 3,4 милиона клиенти, съчетаваме местната си експертиза с мащаба на международна група. Така осигуряваме високи стандарти за защита на данните, надеждни услуги и непрекъснати иновации в съответствие с европейските добри практики.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '3 400 000',
					subtitle: 'лоялни клиенти',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '22+ държави',
					subtitle: 'локална поддръжка, глобален мащаб',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'Лидер в Европа',
					subtitle: 'за уеб хостинг и домейни',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	blockTitle: '',
	blockDesc: '',
	blockContent: {
		left: {
			gap: 'gap24', // classname from css file (block.scss) for space between items
			content: [
				{
					title: 'Local expertise. European strength.',
					text: 'As part of <a href="https://team.blue" target="_blank" rel="nofollow">team.blue</a>, a trusted European digital partner serving more than 3.4 million customers, we combine local expertise with European scale, delivering high standards of data protection, reliable service, and continuous innovation aligned with European best practices.',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		right: {
			gap: 'gap-8-12', // classname from css file (block.scss) for space between items
			content: [
				{
					title: '3 400 000',
					subtitle: 'loyal customers',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: '22+ countries',
					subtitle: 'local support, global scale',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				},
				{
					title: 'European leader',
					subtitle: 'in web hosting and domain services',
					description: '',
					buttonText: '',
					buttonAction: '',
					buttonParams: [],
					ButtonModal: ''
				}
			]
		},
		noteData: []
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];